<template>
  <v-container fill-height>
    <v-layout justify-center align-center wrap>
      <v-flex xs12 sm10 md8 lg6 xl4>
        <v-spacer></v-spacer>
        <v-btn
          class="large"
          xs
          small
          md
          lg
          block
          large
          color="info"
          @click="parent_login = !parent_login"
        >Parent Login</v-btn>
        <form @keyup.enter.prevent="loginUser" v-if="parent_login">
          <v-card class="elevation-10" style="max-width: 580px; margin: auto;">
            <v-card-text>
              <div v-if="laravelErrors.active" class="text-xs-center" style="overflow-x: auto;">
                <v-chip label color="red" text-color="white">{{ laravelErrors.message }}</v-chip>
              </div>
              <v-text-field
                name="email"
                type="email"
                v-model="email"
                label="Email"
                prepend-icon="email"
                v-validate="'required|email'"
              ></v-text-field>
              <div class="error--text text-xs-center">{{ errors.first('email') }}</div>
              <v-text-field
                type="password"
                v-model="password"
                label="Password"
                name="password"
                prepend-icon="lock"
                v-validate="'required'"
              ></v-text-field>
              <div class="error--text text-xs-center">{{ errors.first('password') }}</div>
            </v-card-text>
            <v-card-actions class="px-5 pb-3" style="flex-wrap: wrap;">
              <v-layout row wrap>
                <a @click="$router.push({name: 'ResetForm'})">Forgot Password?</a>
                <v-spacer></v-spacer>
                <a @click="$router.push({name: 'Register'})">Need to Register?</a>
              </v-layout>
              <v-spacer></v-spacer>
              <v-btn id="login" color="primary" @click="loginUser" :loading="loading">Login</v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import throttle from "lodash.throttle";

export default {
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      parent_login: false
    };
  },
  computed: {
    laravelErrors() {
      return this.$store.state.errorModule.general;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit("clearErrors");
    });
  },
  methods: {
    loginUser: throttle(function() {
      this.loading = true;
      this.$store.commit("clearErrors");

      this.$validator.validateAll().then(result => {
        if (result) {
          let credentials = {
            email: this.email,
            password: this.password
          };
          // timer is for UX, so user knows button was clicked and form was submitted
          setTimeout(() => {
            this.$store
              .dispatch("login", credentials)
              .catch(() => (this.loading = false));
          }, 500);
        } else {
          this.loading = false;
        }
      });
    }, 1000)
  }
};
</script>
